const styles = () => ({
  messageWrapper: {
    marginTop: 50,
    textAlign: 'center',
  },
  messageIcon: {
    width: 60,
    height: 60,
    color: 'rgba(0,0,0,.54)',
    marginTop: 50,
  },
  messageBody: {
    margin: '50px 0 25px 0',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/catalog/styles.js